import { z } from 'zod';
import { baseObjectSchema, baseSchema } from '../baseSchemas';
import { getQSTTransactionMasterSchema } from './getQSTTransactionMaster';

export const getQSTTransactionDetailsSchema = z.array(
  baseObjectSchema.extend({
    qstTransactionMasterID: z.string(),
    qstTransactionMaster: getQSTTransactionMasterSchema.optional(),
    groupItemID: z.string().optional(),
    groupItem: baseSchema.optional(),
    materialID: z.string().optional(),
    material: baseSchema.optional(),
    answerValue: z.string().optional(),
    qstActionDetailID: z.string().optional(),
    qstActionDetail: baseSchema.optional(),
  })
);
export type GetTransactionDetailsResponse = z.infer<typeof getQSTTransactionDetailsSchema>;
